import { DocumentNode, gql, useQuery } from "@apollo/client";
import { useUserPlan } from "../auth/plans/useUserPlan";
import { GraphQlPaginated, GraphQlQueryResponse } from "../general/GraphQlQueryResponse";
import { NodeInfoFragment } from "../node/INodeInfo";
import { ILiquidityAdNode } from "./ILiquidityAdNode";




function getQuery(isSubscribed: boolean): DocumentNode {
  return gql`
  ${NodeInfoFragment(isSubscribed)}

  query LiquidityAdsNodesPaginated($amountSat: Float!, $limit: Float!, $skip: Float!, 
    $onchainSatPerVByte: Float!, $nodeChannelCount: Float, $nodeCapacitySat: Float) {
    LiquidityAdNodes(amountSat: $amountSat, limit: $limit, skip: $skip, 
      onchainSatPerVByte: $onchainSatPerVByte, nodeChannelCount: $nodeChannelCount, nodeCapacitySat: $nodeCapacitySat) {
      skip
			limit
      count
      elements {
        openFeeSat
        node {
          ...NodeInfoFragment
        }
      }
    }
  }`
}



export function useLiquidityAdNodes(amountSat: number, onchainSatPerVByte: number, skip: number, limit: number, filters: Map<string, number>): GraphQlQueryResponse<GraphQlPaginated<ILiquidityAdNode>> {
  const userPlan = useUserPlan();
  const QUERY = getQuery(userPlan.plan === 'SUBSCRIBED');
  const query = useQuery(QUERY, {
    variables: {
      amountSat,
      skip,
      limit,
      onchainSatPerVByte,
      ...Object.fromEntries(filters)
    },
  },
  );
  const nodeInfo = query.data?.LiquidityAdNodes;

  return {
    loading: query.loading,
    error: query.error,
    data: nodeInfo,
    refetch: query.refetch,
    fetchMore: query.fetchMore
  };
}